<template>
  <form id="frm">
    <div class="popup_wrap" style="width:600px; max-height: 900px; margin-top: -80px;">
      <button class="layer_close" @click="$emit('close')">close</button>
      <div class="popup_cont">
        <!-- content_box -->
        <form id="frm">
          <div class="content_box">
            <table class="tbl_row mt10">
              <colgroup>
                <col style="width:15%">
                <col style="width:auto">
              </colgroup>
              <tbody>
                <tr>
                  <th style="text-align: center;">{{ $t('msg.MYIN010G010.004') }}</th> <!-- 선택 -->
                  <th style="text-align: center;">
                    {{ $t('msg.ONEX010T010.166') }}
                  </th> <!-- 대표 포트 -->
                </tr>
                <tr v-for="(item,index) in sectionList" :key="index">
                  <td>
                    <input type="checkbox" :name="item.cd" :id="item.cd" v-model="item.fakChkYn" true-value="Y" false-value="N">
                    <label :for="item.cd" style="margin-left: 35%;"></label>
                  </td>
                  <td style="text-align: center;" class="multi-line-css">{{ item.dsc }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
        <div class="mt10 text_center">
          <a class="button blue lg" href="#" @click.prevent="onConfirm()">{{ $t('btn.CMBTK013') }}</a><!-- 확인 -->
          <a class="button gray lg" href="#" @click.prevent="$emit('close')">{{ $t('msg.MYIN020T020.046') }}</a><!-- 닫기 -->
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import scheduleApi from '../../../api/rest/schedule/schedule'

export default {
  name: 'FakFreightSectionSettingPop',
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      sectionList: [], // CD , DSC, FAK_CHK_YN
      fakPopInfo: {}
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getFakFreightSectionList()
    },
    //저장 버튼 클릭 시
    async onConfirm () {
        let fakPortRmk = ''
        this.sectionList.forEach((item) => {
          if (item.fakChkYn === 'Y') {
            fakPortRmk += item.cd.trim() + ' '
          }
        })
        this.fakPopInfo = {
          fakPortRmk: fakPortRmk.trim().replaceAll(' ', ', '),
          sectionList: this.sectionList
        }
        if (await this.$ekmtcCommon.isEmpty(fakPortRmk)) {
          this.$ekmtcCommon.asyncAlertMessage({ message: '구간을 선택해 주세요.' })
          return
        }
        if (await this.$ekmtcCommon.asyncAlertMessage({ message: '임시저장이 완료 되었습니다.<br>프로필 저장 시 최종적으로 저장 됩니다.' })) {
          this.closeFunc()
        }
    },
    closeFunc () {
      this.$emit('close', this.fakPopInfo)
    },
    //FAK운임 구간 목록 조회
    getFakFreightSectionList () {
      scheduleApi.getFakFreightSectionList().then((res) => {
        this.sectionList = res.data.fakFreightList
        //임시 저장을 했을 경우 부모 컴포넌트로부터 받아온 fakChkYn 값 적용
        if (this.parentInfo?.sectionList.length > 0) {
          this.sectionList.forEach((item, index) => {
            item.fakChkYn = this.parentInfo?.sectionList?.at(index)?.fakChkYn
          })
        }
      }).catch(error => {
          console.log(error)
      })
    }
  }
}
</script>

<style>
.multi-line-css {
    white-space: pre !important;
    text-align: center;
}
</style>
